<div class="subtask-assignee-menu" *ngIf="isVisible" [style.top.px]="position.top" [style.left.px]="position.left">
  <div class="menu-content">
    <div class="search-section">
      <input 
        type="text" 
        class="search-input"
        [(ngModel)]="searchQuery" 
        (ngModelChange)="onSearchChange($event)"
        placeholder="{{ 'request_v2.assignee_selector.search_placeholder' | translate }}"
        (click)="$event.stopPropagation()"
      >
    </div>

    <div class="menu-body">
      <div class="loading-indicator" *ngIf="loading">
        <mat-spinner diameter="20"></mat-spinner>
      </div>
      
      <div class="menu-items" *ngIf="!loading">
        <div class="menu-item unassigned-option" (click)="onUnassignedSelect(); $event.stopPropagation()">
          <div class="selection-indicator">
            <div class="radio" [class.radio-selected]="!selectedAssigneeId"></div>
          </div>
          <div class="item-details">
            <div class="item-name">{{ 'request_v2.assignee_selector.unassigned' | translate }}</div>
          </div>
          <div class="item-avatar">
            <div class="initials-circle empty"></div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="menu-item" 
          *ngFor="let admin of filteredAdmins" 
          [class.selected]="isAdminSelected(admin.id)"
          (click)="onAssigneeSelect(admin); $event.stopPropagation()"
        >
          <div class="selection-indicator">
            <div class="radio" [class.radio-selected]="isAdminSelected(admin.id)"></div>
          </div>
          
          <div class="item-details">
            <div class="item-name">{{ admin.name }}</div>
            <div class="item-email">{{ admin.email }}</div>
          </div>
          
          <div class="item-avatar">
            <div class="initials-circle" *ngIf="!admin.picture">{{ admin.initials }}</div>
            <img *ngIf="admin.picture" [src]="admin.picture" class="admin-avatar" alt="{{ admin.name }}" />
          </div>
        </div>
        
        <div class="no-results" *ngIf="filteredAdmins.length === 0">
          {{ 'request_v2.assignee_selector.no_results' | translate }}
        </div>
      </div>
    </div>
  </div>
</div> 